module.exports = __webpack_public_path__ + "img/login-logo.d5447b38.png";